import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import FullStatusPostItem from '../components/FullStatusPostItem';

export default function FullStatusPage() {
  const { statusId } = useParams(); // Get statusId from URL
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch the status by ID
  useEffect(() => {
    async function fetchStatus() {
      try {
        const statusRef = doc(db, 'status', statusId);
        const statusSnap = await getDoc(statusRef);
        if (statusSnap.exists()) {
          setStatus({ id: statusSnap.id, ...statusSnap.data() });
        } else {
          setError('Status not found');
        }
      } catch (err) {
        console.error('Error fetching status:', err);
        setError('Failed to load status');
      } finally {
        setLoading(false);
      }
    }
    fetchStatus();
  }, [statusId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black snap-y snap-mandatory overflow-y-scroll">
      <FullStatusPostItem status={status} />
    </div>
  );
}